import React from "react";
import {
  Box,
  Divider,
  Typography,
  Button,
  Card,
  Container,
  Dialog, DialogTitle, DialogContent, DialogActions, Badge
} from "@mui/material";
import Account from "./Account";
import { useRef, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import WidgetsIcon from '@mui/icons-material/Widgets';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import LogoutIcon from '@mui/icons-material/Logout';
import { useUser } from "../../context/LoginDetail";
import { remove_account } from "../../api/authApi";
import { toast } from "react-toastify";

//this as a dashboard layout 
export default function ProfileScreen() {
  const [menuOpen, setMenuOpen] = React.useState(true);
  const [openMaterial, setOpenMaterial] = React.useState(false);
  const [openEnquiry, setOpenEnquiry] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  // Close dialog
  const handleClose = () => setOpen(false);

  // Confirm delete
  const handleConfirmDelete = () => {

    remove_account(user?.id)
      .then((res) => {
        toast.success(res?.data.message || "Account Deleted Successfully")
        setOpen(false);

        localStorage.removeItem("authToken")
        localStorage.removeItem("user");
        localStorage.removeItem("phone")
        navigate('/')
      })
      .catch((err) => {

      });
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    localStorage.removeItem("phone");
    toast.success("Logged out successfully");
    navigate('/');
  };

  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1200) {
        setMenuOpen(true);
      }
      else {
        setMenuOpen(false);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  React.useEffect(() => {
    if (menuOpen && window.innerWidth < 1200) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen]);

  const [selectedPage, setSelectedPage] = React.useState("Profile");
  const navigate = useNavigate();
  const location = useLocation();
  const { user, notificationCount } = useUser();
  const isVendorApproved = Number(user?.is_vendor) === 1;
  const isServiceApproved = Number(user?.is_services) === 1;

  const companySubMenu = [
    ...(isVendorApproved || isServiceApproved
      ? [{ name: "My Company Profile", path: "/dashboard/company-profile" , img: "/assets/icons/company-vision.png"}]
      : []),
    ...(isServiceApproved
      ? [{ name: "My Service", path: "/dashboard/add-service", img: "/assets/icons/support1.png" }]
      : []),
    ...(isServiceApproved
      ? [{ name: "My Service Enquiry List", path: "/dashboard/my-service-enquiry", img: "/assets/images/headphones.png" }]
      : []),
    ...(isVendorApproved
      ? [{ name: "My Material", path: "/dashboard/add-material", img: "/assets/icons/technical-support.png" }]
      : []),
    ...(isVendorApproved
      ? [{ name: "My Material Enquiry List", path: "/dashboard/my-material-enquiry", img: "/assets/icons/material_enquiry.png" }]
      : []),
  ];

  const enquirySubMenu = [
    { name: "Land Enquiry", path: "/dashboard/marketingplace-enquiry", img: "/assets/icons/marketingenquiry.png" },
    { name: "Material Enquiry", path: "/dashboard/material-enquiry", img: "/assets/icons/material_enquiry.png" },
    { name: "Service Enquiry", path: "/dashboard/service-enquiry", img: "/assets/images/headphones.png" },
    { name: "Flats / Villas Enquiry", path: "/dashboard/residential_enquiry", img: "/assets/icons/add_property.png" },
    { name: "Rental Yield Enquiry", path: "/dashboard/rental_enquiry", img: "/assets/icons/rental_icon.png" },
  ];

  const items = [
    { name: "My Dashboard", img: "/assets/icons/setting.png", path: "/dashboard/my-dashboard" },
    { name: "Notification", img: "/assets/icons/notifications.png", path: "/dashboard/notifications" },
    { name: "My Profile", img: "/assets/icons/user.png", path: "/dashboard/account" },
    { name: "Gift/Payment Coupons", img: "/assets/icons/purchase-coupon", path: "/dashboard/purchase-coupon" },
    { name: "Encashment", img: "/assets/icons/encashment.png", path: "/dashboard/encashment" },
    ...(companySubMenu.length > 0
      ? [{
        name: "Company Profile",
        img: "/assets/icons/materialsub.png",
        path: "/dashboard/company-profile",
        subMenu: companySubMenu,
        isOpen: openMaterial,
        setOpen: setOpenMaterial
      }]
      : []),
    {
      name: "Enquiry List",
      img: "/assets/icons/materialsub.png",
      path: "/dashboard/marketingplace-enquiry",
      subMenu: enquirySubMenu,
      isOpen: openEnquiry,
      setOpen: setOpenEnquiry
    },
    { name: "My Land", img: "/assets/icons/residential_icon_menu.png", path: "/dashboard/my_markplace_plot" },
    { name: "My Flats / Villas", img: "/assets/icons/residental_enquiry_icon.png", path: "/dashboard/my_residential_property" },
    { name: "Buying List", img: "/assets/icons/buyinglist_icon.png", path: "/dashboard/buying-list" },
    { name: "List My Property", img: "/assets/icons/material_enquiry.png", path: "/dashboard/general-enquiry" },
    { name: "General Enquiry", img: "/assets/icons/material_enquiry.png", path: "/dashboard/custom-land-enquiry" },
    { name: "Account Details", img: "/assets/icons/Wallet.png", path: "/dashboard/account-details" },
  ];


  const renderPage = () => {
    switch (selectedPage) {
      case "My Profile":
        return <Account />
      case "My Material Enquiry":
        return <h2>My Product Enquiry Page</h2>;

      case "My Service Enquiry":
        return <h2>My Service Enquiry Page</h2>;

      case "Group Chat":
        return <h2>Group Chat Page</h2>;

      case "About Us":
        return <h2>About Us Page</h2>;

      // case "Contact Us":
      //   return <h2>Contact Us Page</h2>;

      default:
        return <Account />;
    }
  };

  const sidebarRef = useRef();

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        window.innerWidth < 1200
      ) {
        setMenuOpen(false); // close sidebar if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <Container>
      <Box
        className="col-md-12"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          gap: 6,
          py: { xs: 2, md: 8 },
          justifyContent: "center",
          alignItems: { xs: "center", lg: "flex-start" },
          background: "white",
        }}>
        <Button
          onClick={() => setMenuOpen(!menuOpen)}
          sx={{
            display: { xs: "block", lg: "none" },
            mb: 2,
            px: 1,
            minWidth: "auto",
            alignSelf: "flex-start",
          }}>
          <WidgetsIcon alt="menu" style={{ width: 25 }} />
        </Button>

        <Card
          ref={sidebarRef}
          sx={{
            transition: "all 0.3s ease",
            transform: {
              xs: menuOpen ? "translateX(0)" : "translateX(-110%)",
              sm: menuOpen ? "translateX(0)" : "translateX(-110%)",
              md: menuOpen ? "translateX(0)" : "translateX(-110%)",
              // lg: "translateX(0)", // >=1200px always show
            },
            // transform: { xs: menuOpen ? "translateX(0)" : "translateX(-110%)", md: "translateX(0)" },
            position: { xs: "fixed", lg: "relative" },

            left: 0,
            bottom: 0,
            top: { xs: 64, lg: "auto" }, // ⬅ push below header
            height: { xs: "calc(100vh - 64px)", lg: "auto" },

            width: { xs: "70%", sm: "60%", md: "50%", lg: 300 },
            maxHeight: { xs: "100vh", lg: "100vh", xl: "none" },
            p: 3,

            borderRadius: 4,
            boxShadow: 4,
            border: "1px solid #e5e5e5",
            zIndex: { xs: 4800, md: 1000 },
            bgcolor: "white",
            overflowY: { xs: "auto", lg: "visible" },
            WebkitOverflowScrolling: "touch",
          }}
        >
          {/* CLOSE BUTTON */}
          {menuOpen && (
            <Box
              sx={{
                display: { xs: "flex", lg: "none" },
                justifyContent: "flex-end",
                alignItems: "center",
                px: 1
              }}
            >
              <Button
                onClick={() => setMenuOpen(false)}
                aria-label="Close menu"
                sx={{
                  minWidth: "auto",
                  mt: { xs: 0, md: 3, lg: 0 },
                  height: 36,
                  borderRadius: "50%",
                  color: "error.main",
                  fontSize: 20,
                  fontWeight: "bold",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "error.light",
                    color: "error.contrastText",
                    transform: "rotate(90deg)"
                  },
                  "&:active": {
                    transform: "scale(0.95)"
                  }
                }}
              >
                ✕
              </Button>
            </Box>
          )}

          {/* {menuOpen && (
            <Box sx={{ display: { xs: "flex", lg: "none" }, justifyContent: "flex-end" }}>
              <Button
                onClick={() => setMenuOpen(false)}
                sx={{
                  minWidth: "auto",
                  p: 1,
                  color: "red"
                }}
              >
                ✕
              </Button>
            </Box>
          )} */}

          {/* MENU ITEMS */}
          {/* <Box sx={{ mt: { xs: 2, md: 0 } }}>
            {items.map((item, i) => {
              const isActive = location.pathname.includes(item.path);
              return (
                <Box key={i}>
                  <Button
                    fullWidth
                    sx={{
                      justifyContent: "flex-start",
                      py: 1.5,
                      gap: 2,
                      textTransform: "none",
                      fontSize: 15,
                      color: isActive ? "primary.main" : "#444",
                      fontWeight: isActive ? 700 : 500,
                    }}
                    onClick={() => {
                      navigate(item.path);
                      if (window.innerWidth < 1200) {
                        setMenuOpen(false);
                      }
                    }}
                  >
                    <img src={item.img} alt="icon" style={{ width: 22 }} />
                    {item.name}
                  </Button>
                  <Divider sx={{ my: 1, borderBottom: "1px solid #c1c1c1" }} />
                </Box>
              );
            })}

         
          </Box> */}
          <Box sx={{ mt: { xs: 1, md: 0 } }}>
            {items.map((item, i) => {
              const isActive = location.pathname.includes(item.path);
              const hasSubMenu = item.subMenu && item.subMenu.length > 0;

              return (
                <Box key={i}>
                  {/* MAIN MENU */}
                  <Button
                    fullWidth
                    sx={{
                      justifyContent: "flex-start",
                      py: 1,
                      px: 1,
                      gap: 1.5,
                      textTransform: "none",
                      fontSize: 14,
                      color: isActive ? "#3B6019" : "#333333",
                      fontWeight: isActive ? 700 : 500,
                      borderRadius: "12px",
                      "&:hover": {
                        bgcolor: "#F4F8F3",
                      },
                    }}
                    onClick={() => {
                      if (hasSubMenu) {
                        item.setOpen(prev => !prev);
                      } else {
                        navigate(item.path);
                        if (window.innerWidth < 1200) {
                          setMenuOpen(false);
                        }
                      }
                    }}
                  >
                    <Box
                      sx={{
                        width: 34,
                        height: 34,
                        borderRadius: "50%",
                        bgcolor: isActive ? "#EBF6E9" : "#F4F7F3",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <img src={item.img} alt="icon" style={{ width: 18, height: 18, objectFit: "contain" }} />
                    </Box>
                    <Box sx={{ flexGrow: 1, textAlign: "left" }}>
                      {item.name}
                    </Box>
                    {item.name === "Notification" && notificationCount > 0 && (
                      <Badge
                        badgeContent={notificationCount}
                        color="error"
                        sx={{
                          mr: 1,
                          "& .MuiBadge-badge": {
                            fontSize: "10px",
                            height: 18,
                            minWidth: 18,
                          },
                        }}
                      />
                    )}
                    <ChevronRightIcon sx={{ fontSize: 18, color: isActive ? "#3B6019" : "#C4C4C4" }} />
                  </Button>

                  {/* SUB MENU */}
                  {hasSubMenu && item.isOpen && (
                    <Box sx={{ pl: 5, py: 0.5 }}>
                      {item.subMenu.map((sub, si) => {
                        const isSubActive = location.pathname.includes(sub.path);

                        return (
                          <Button
                            key={si}
                            fullWidth
                            sx={{
                              justifyContent: "flex-start",
                              py: 0.8,
                              fontSize: 13,
                              textTransform: "none",
                              color: isSubActive ? "#3B6019" : "#666",
                              fontWeight: isSubActive ? 600 : 400,
                              gap: 1.5
                            }}
                            onClick={() => {
                              navigate(sub.path);
                              if (window.innerWidth < 1200) {
                                setMenuOpen(false);
                              }
                            }}
                          >
                            {sub.img ? <img src={sub.img} alt="icon" style={{ width: 16 }} /> : "▸"}
                            {sub.name}
                          </Button>
                        );
                      })}
                    </Box>
                  )}

                  <Divider sx={{ my: 0.8, borderColor: "#F0F4EE" }} />
                </Box>
              );
            })}

            {/* LOGOUT ITEM */}
            <Button
              fullWidth
              sx={{
                justifyContent: "flex-start",
                py: 1,
                px: 1,
                gap: 1.5,
                textTransform: "none",
                fontSize: 14,
                color: "#FF4D4D",
                fontWeight: 600,
                borderRadius: "12px",
                "&:hover": {
                  bgcolor: "#FFF0F0",
                },
              }}
              onClick={() => setLogoutDialogOpen(true)}
            >
              <Box
                sx={{
                  width: 34,
                  height: 34,
                  borderRadius: "50%",
                  bgcolor: "#FEEBEB",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <LogoutIcon sx={{ fontSize: 18, color: "#FF4D4D" }} />
              </Box>
              <Box sx={{ flexGrow: 1, textAlign: "left" }}>
                Logout
              </Box>
            </Button>

            {/* Logout Modal */}
            <Dialog
              open={logoutDialogOpen}
              onClose={() => setLogoutDialogOpen(false)}
              PaperProps={{
                sx: {
                  borderRadius: "24px",
                  p: 4,
                  maxWidth: 360,
                  width: "100%",
                  textAlign: "center",
                }
              }}
            >
              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  bgcolor: "#FEEBEB",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
                <LogoutIcon sx={{ fontSize: 28, color: "#D32F2F" }} />
              </Box>

              <Typography sx={{ fontWeight: 800, fontSize: "20px", color: "#111111", mb: 1 }}>
                Taking a break?
              </Typography>

              <Typography sx={{ color: "#666666", fontSize: "13px", lineHeight: 1.5, mb: 3 }}>
                Don't worry, we've stored your progress. Don't keep everything in your head, see you soon!
              </Typography>

              <Button
                fullWidth
                onClick={handleLogout}
                sx={{
                  height: 46,
                  borderRadius: "24px",
                  bgcolor: "#D32F2F",
                  color: "#ffffff",
                  fontWeight: 700,
                  fontSize: "14px",
                  textTransform: "none",
                  mb: 1.5,
                  "&:hover": {
                    bgcolor: "#B71C1C",
                  },
                }}
              >
                Log me out
              </Button>

              <Button
                fullWidth
                onClick={() => setLogoutDialogOpen(false)}
                sx={{
                  height: 46,
                  borderRadius: "24px",
                  bgcolor: "#FEEBEB",
                  color: "#D32F2F",
                  fontWeight: 700,
                  fontSize: "14px",
                  textTransform: "none",
                  "&:hover": {
                    bgcolor: "#FCD8D8",
                  },
                }}
              >
                Keep me logged in
              </Button>
            </Dialog>

            <Dialog open={open} onClose={handleClose}>
              <DialogTitle>Confirm Delete</DialogTitle>
              <DialogContent>
                <Typography>Are you sure you want to delete your account? This action cannot be undone.</Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleConfirmDelete} color="error">
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
          </Box>


        </Card>
        <Box sx={{ flex: 1, width: "100%" }}>
          <Outlet />
        </Box>
      </Box>
    </Container>

  );
}

